import React from 'react';

const DISCLOSURES = [
  ['Brokerage Disclosure', 'Jessica Burnette is a licensed real estate agent in the Commonwealth of Virginia (License #0225252447) and the State of North Carolina (License #337285), affiliated with Swell Realty Co., located at 2122 General Booth Blvd Suite 104, Virginia Beach, VA 23454.'],
  ['Agency Disclosure', 'Virginia law requires real estate licensees to disclose their agency relationships prior to providing brokerage services. The type of agency relationship between you and Jessica Burnette will be disclosed and documented prior to any real estate transaction.'],
  ['Fair Housing Statement', 'We are committed to providing an inclusive and welcoming environment for all clients, customers, and guests. We fully comply with the Fair Housing Act and do not discriminate based on race, color, religion, sex, national origin, familial status, disability, sexual orientation, gender identity, or any other protected class.'],
  ['MLS Data Disclaimer', 'Information deemed reliable but not guaranteed. All properties are subject to prior sale, change, or withdrawal. Neither listing broker(s), nor Swell Realty Co. shall be responsible for any typographical errors, misinformation, misprints, and shall be held totally harmless.'],
  ['Veterans United Disclaimer', 'Jessica Burnette is a Veterans United Preferred Agent. Veterans United Home Loans is a private corporation and is not affiliated with the U.S. government or any government agency.'],
];

const LEGAL_LINKS = ['Terms of Service', 'Accessibility', 'DMCA Notice'];

export const FooterBadges = () => (
  <div className="border-t border-white/10 bg-[#0B1F3F]/80">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="flex flex-col md:flex-row items-center justify-center gap-6">
        <div className="flex items-center space-x-3">
          <div className="bg-sand-50 p-1.5 rounded">
            <svg viewBox="0 0 48 48" className="w-8 h-8">
              <rect fill="#000" width="48" height="48" />
              <path fill="#fff" d="M24 6L6 20v2h4v20h28V22h4v-2L24 6zm12 34H12V20.8L24 11.6l12 9.2V40z" />
            </svg>
          </div>
          <span className="text-white/60 text-xs">Equal Housing Opportunity</span>
        </div>
        <span className="hidden md:inline text-white/30">•</span>
        <span className="text-white/60 text-xs">Member of National Association of REALTORS®</span>
        <span className="hidden md:inline text-white/30">•</span>
        <span className="text-white/60 text-xs">Veterans United Preferred Agent</span>
      </div>
    </div>
  </div>
);

export const FooterLegal = ({ openPrivacyPolicy }) => (
  <div className="border-t border-white/10 bg-[#0B1F3F]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="text-white/50 text-xs space-y-4">
        <p className="text-center">© {new Date().getFullYear()} Jessica Burnette | Jess Sells East Coast | REALTOR® | MRP® | All Rights Reserved</p>
        <div className="space-y-3 text-xs leading-relaxed">
          {DISCLOSURES.map(([title, text]) => (
            <p key={title}><strong className="text-white/70">{title}:</strong> {text}</p>
          ))}
        </div>
        <div className="flex flex-wrap items-center justify-center gap-4 pt-4 border-t border-white/10 text-white/40">
          <button data-testid="footer-privacy-link" onClick={openPrivacyPolicy} className="hover:text-gold-400 transition-colors cursor-pointer">Privacy Policy</button>
          {LEGAL_LINKS.map((label) => (
            <React.Fragment key={label}><span>•</span><span>{label}</span></React.Fragment>
          ))}
        </div>
      </div>
    </div>
  </div>
);
